import type { CuratedModelTag } from "../data/curated-models";
import type { ModelRelease, TimelineRelease } from "../types/model";

export interface DetailNavigationLists {
  /** The open group panel's timeline entry, or null when no panel is open. */
  group: TimelineRelease | null;
  /** The curated bar the detail was opened from, or null for the timeline. */
  curated: CuratedModelTag | null;
  flagship: ModelRelease[];
  milestone: ModelRelease[];
  timeline: TimelineRelease[];
}

/**
 * The list an open detail's previous and next walk. Inside a group panel it is
 * the group's members. A detail opened from the Flagship or Milestone bar walks
 * that bar's models in the bar's own order (owner decision, 2026-10-29), which
 * also keeps a grouped member reachable: the folded timeline shows it only as
 * its group's card. Anything else walks the timeline.
 */
export function detailNavigation({
  group,
  curated,
  flagship,
  milestone,
  timeline
}: DetailNavigationLists): TimelineRelease[] {
  if (group?.groupView) return group.groupView.members;
  if (curated === "flagship") return flagship;
  if (curated === "milestone") return milestone;
  return timeline;
}
